import { FaGoogle, FaDiscord } from 'react-icons/fa';

export const GoogleIcon = (props) => <FaGoogle {...props} />;
export const DiscordIcon = (props) => <FaDiscord {...props} />;
